// extracted by mini-css-extract-plugin
module.exports = {"faqs":"faqs_faqs__1fV1H","faq-blocks":"faqs_faq-blocks__3xCLF","faq-question":"faqs_faq-question__3JpEq","faq-answers":"faqs_faq-answers__3UItX"};